
import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui/index.js';
import './style.scss';

export default function consumer(data) {
  /* Render Customer Message */
  const aniClass = data.removeAni ? '' : 'bubble-up-from-right';
  const param = {
    name: 'consumer',
    mid: data.mid,
    contentType: data.contentType ? ` -${data.contentType}` : '',
    content: data.text,
    side: `right ${aniClass}`,
    type: data.type,
  };

  const $node = $(BaseUI.msg(param));
  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/consumer/index.js